/*
SESSION TYPES:
- presentation
  - presentation with author
- meta
  - other than presentations such as coffee break, etc.
  - for meta sessions without defined track will be populated cross session `track`
*/

const DAY = '2020-03-19'

const coffeeBreakImage = require('../resources/coffee-break.jpg')

const track1 = 'hall1'
const other = 'other'

function presentation(time, key) {
  return {
    date: DAY,
    time,
    track: track1,
    presentation: key,
  }
}

function coffeeBreak(time) {
  return {
    date: DAY,
    time,
    track: other,
    meta: {
      title: 'Coffee break',
      image: coffeeBreakImage,
      imageWidth: 560,
    },
  }
}

export default [
  {
    date: DAY,
    time: '09:00',
    track: other,
    meta: {
      title: 'Registration',
    },
  },
  presentation('10:00', 'fr_be_at'),
  coffeeBreak('11:00'),
  presentation('11:45', 'ge_mx_id'),
  coffeeBreak('12:45'),
  presentation('13:30', 'by_ua'),
  coffeeBreak('14:30'),
  {
    date: DAY,
    time: '15:30',
    track: other,
    meta: {
      title: 'End',
    },
  },
]



// WEBPACK FOOTER //
// ./src/content/biznisnet2020/data/sessions.js